var map = {
	"../bought/tab2.module": [
		"./src/app/bought/tab2.module.ts",
		"default~bought-tab2-module~member-member-module~search-search-module",
		"common",
		"bought-tab2-module"
	],
	"../search/search.module": [
		"./src/app/search/search.module.ts",
		"default~bought-tab2-module~member-member-module~search-search-module",
		"common",
		"search-search-module"
	],
	"../sold/sold.module": [
		"./src/app/sold/sold.module.ts",
		"common",
		"sold-sold-module"
	],
	"./login/login.module": [
		"./src/app/login/login.module.ts",
		"common",
		"login-login-module"
	],
	"./member/member.module": [
		"./src/app/member/member.module.ts",
		"default~bought-tab2-module~member-member-module~search-search-module",
		"common",
		"member-member-module"
	],
	"./search/search.module": [
		"./src/app/search/search.module.ts",
		"default~bought-tab2-module~member-member-module~search-search-module",
		"common",
		"search-search-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;